import React, { useEffect } from 'react';

export const CancellationPolicy = ({ onBack, businessLogo }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white relative" dir="rtl">
      <div className="max-w-md mx-auto w-full pb-24">
        {/* Header with Back Button */}
        <div className="sticky top-0 bg-white border-b border-gray-200 z-10">
          <div className="px-4 py-3 flex items-center">
            <button
              onClick={onBack}
              className="flex items-center text-gray-600 hover:text-rose-500 transition-colors duration-200"
            >
              <svg
                className="w-5 h-5 ml-1 transform rotate-180"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              <span className="font-medium">חזרה</span>
            </button>
          </div>
        </div>

        {/* Business Logo */}
        {businessLogo && (
          <div className="w-full py-4 flex justify-center">
            <img
              src={businessLogo}
              alt="Business Logo"
              className="h-12 w-auto object-contain"
            />
          </div>
        )}

        {/* Policy Content */}
        <div className="px-6 py-4">
          <div className="text-right space-y-4">
            {/* Title */}
            <h1 className="text-xl font-bold text-center text-gray-800 mb-6">
              מדיניות ביטולים ושינויים - סיוון מנדל- אסתטיקה ויופי
            </h1>

            {/* Intro */}
            <p className="text-gray-700 leading-relaxed">
              לקוחות יקרים ואהובים,
            </p>
            <p className="text-gray-700 leading-relaxed">
              אני שמחה לארח אתכם אצלי בקליניקה ולהעניק לכם את הטיפול הטוב, המקצועי והמסור ביותר. כדי שאוכל להמשיך להעניק לכל אחד ואחת מכם את מלוא התשומת והזמן המגיע לכם, וכדי לשמור על סדר עבודה שיאפשר זמינות תורים גבוהה, חשוב לי לשתף אתכם במדיניות הביטולים של הקליניקה:
            </p>

            {/* Updates Section */}
            <div className="bg-rose-50 rounded-xl p-4 mt-4">
              <h2 className="font-semibold text-gray-800 mb-2">
                עדכון על שינויים וביטולים:
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                זמנכם יקר לי מאוד, וכך גם זמן העבודה בקליניקה. במידה וחל שינוי בתוכניות, אבקשכם לעדכן אותי מראש:
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-rose-500 ml-2">•</span>
                  <span><strong>לטיפולים של עד שעה:</strong> נא לעדכן על ביטול או שינוי לפחות 24 שעות מראש.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rose-500 ml-2">•</span>
                  <span><strong>לטיפולים מעל שעה:</strong> בשל הזמן הארוך המשוריין עבורכם, נא לעדכן לפחות 48 שעות מראש.</span>
                </li>
              </ul>
            </div>

            {/* Cancellation Fees Section */}
            <div className="bg-gray-50 rounded-xl p-4 mt-4">
              <h2 className="font-semibold text-gray-800 mb-2">
                דמי ביטול:
              </h2>
              <p className="text-gray-700 leading-relaxed">
                אני עושה את מירב המאמצים למלא חללים שמתפנים בלוח הזמנים. עם זאת, במקרה של ביטול ברגע האחרון (פחות מהזמן שצוין לעיל) או אי-הגעה ללא הודעה, הקליניקה שומרת לעצמה את הזכות לגבות 50% מעלות הטיפול.
              </p>
            </div>

            {/* Personal Note Section */}
            <div className="bg-pink-50 rounded-xl p-4 mt-4">
              <h2 className="font-semibold text-gray-800 mb-2">
                מילה ממני:
              </h2>
              <p className="text-gray-700 leading-relaxed">
                אני יודעת שהחיים דינמיים ודברים בלתי צפויים יכולים לקרות לכולנו. במידה וקרה משהו דחוף, אנא דברו איתי בהקדם האפשרי. המדיניות הזו נועדה לאפשר לי להציע את התור שמתפנה ללקוחות אחרים שנמצאים ברשימת ההמתנה, ולכבד את זמן העבודה המוקדש לכם.
              </p>
            </div>

            {/* Closing */}
            <p className="text-gray-700 leading-relaxed mt-4">
              אני מודה לכם מקרב לב על ההבנה, על שיתוף הפעולה ועל הזכות לטפל בכם!
            </p>
            <p className="text-gray-700 font-medium mt-2">
              שלכם, סיוון
            </p>
          </div>
        </div>

        {/* Fixed Back Button at Bottom */}
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg">
          <div className="max-w-md mx-auto px-6 py-4">
            <button
              onClick={onBack}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-4 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 text-lg"
            >
              חזרה
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
